import { Fragment } from 'react'
import { FiCreditCard, FiGift, FiPhoneCall, FiTruck } from 'react-icons/fi'
import { Link } from 'react-router-dom'
import './index.scss'

export function Footer() {
    let year = new Date().getFullYear()
    return (
        <Fragment>
            <div className="bg-white border-bottom desktop">
                <div className="max-width p-x top-footer">
                    <div className="top-footer-child">
                        <i><FiTruck /></i>
                        <span>
                            free shipping from $500
                        </span>
                    </div>
                    <span className="vertical-line"></span>
                    <div className="top-footer-child">
                        <i><FiPhoneCall /></i>
                        Support 24/7 At Anytime
                    </div>
                    <span className="vertical-line"></span>
                    <div className="top-footer-child">
                        <i><FiCreditCard /></i>
                        Secure Payment Totally Safe
                    </div>
                    <span className="vertical-line"></span>
                    <div className="top-footer-child">
                        <i><FiGift /></i>
                        Latest Offer Upto 20% Off
                    </div>
                    <span className="vertical-line"></span>
                </div>
            </div>
            <div className="max-width p-x footer">
                <div className="footer-child">
                    <div className="footer-child-head">company</div>
                    <div className="footer-child-list">
                        <Link to='about-us'>about us</Link>
                        <Link to='contact-us'>contact us</Link>
                        <Link to='careers'>careers</Link>
                        <Link to='latest news'>latest news</Link>
                    </div>
                </div>
                <div className="footer-child">
                    <div className="footer-child-head">Top Category</div>
                    <div className="footer-child-list">
                        <Link to='about-us'>fish & meat</Link>
                        <Link to='contact-us'>soft drinks</Link>
                        <Link to='careers'>baby care</Link>
                        <Link to='latest news'>beauty & health</Link>
                    </div>
                </div>
                <div className="footer-child">
                    <div className="footer-child-head">My Account</div>
                    <div className="footer-child-list">
                        <Link to='about-us'>dashboard</Link>
                        <Link to='contact-us'>my orders</Link>
                        <Link to='careers'>recent orders</Link>
                        <Link to='latest news'>updated profile</Link>
                    </div>
                </div>
                <div className="footer-child">
                    <div className="footer-child-head">p-shop</div>
                    <div className="footer-child-list">
                        <span>987 Andre Plain Suite High Street 838,</span>
                        <span>Lake Hestertown, USA</span>
                        <span>Tell: 02.356.1666</span>
                        <span>
                            Email: <span className='text-lower'>izuchukwue2@gmail.com</span>
                        </span>
                    </div>
                </div>
            </div>
            <span className="bottom-footer">
                Copyright {year} @<a rel="noreferrer" target={'_blank'} href="https://www.github.com/noblesalt">EmmanuelDjango</a>, All rights reserved.
            </span>
        </Fragment>
    )
}